import VehicleConfiguration from './containers/VehicleConfiguration';
import withRole from '../../hocs/withRole';

export default [{
  path: '/vehicleconfiguration',
  exact: true,
  component: withRole(['Vehicle Admin', 'Client Admin'], VehicleConfiguration),
}];
